import clsx from 'clsx';
import type { FunctionComponent, HTMLAttributes, ReactNode } from 'react';

type TileProps = HTMLAttributes<HTMLDivElement> & {
    readonly children: ReactNode;
};

export const TileBase: FunctionComponent<TileProps> = ({ children, className, ...props }) => (
    <div
        className={clsx(
            'flex flex-col items-start justify-start font-sans',
            'bg-white-200 border border-gray-300 rounded-xxxl',
            'gap-xxl h-full w-full box-border',
            'overflow-hidden',
            className,
        )}
        {...props}
    >
        {children}
    </div>
);

export const Tile: FunctionComponent<TileProps> = ({ children, ...props }) => {
    return (
        <TileBase data-can-have-focus="true" data-testid="tile" tabIndex={0} {...props}>
            {children}
        </TileBase>
    );
};

type TileContentProps = HTMLAttributes<HTMLDivElement> & {
    readonly children: ReactNode;
};

export const TileTitle: FunctionComponent<HTMLAttributes<HTMLHeadingElement> & { readonly children: ReactNode }> = ({
    children,
    className,
    ...props
}) => (
    <h2
        className={clsx('flex text-black-700 text-base font-medium leading-[1.5rem] tracking-tight m-0', className)}
        {...props}
    >
        {children}
    </h2>
);

export const TileContent: FunctionComponent<TileContentProps> = ({ children, className, ...props }) => (
    <div
        className={clsx(
            'flex flex-col items-start justify-start',
            'gap-xxl h-full box-border',
            'pb-xxl px-6xl',
            className,
        )}
        {...props}
    >
        {children}
    </div>
);
